/* RNG — "Complete your collection" (cart page, cart drawer, added-to-cart pop-up).
   Upgrades each recommendation to show the real variant: its picture, its name and its price,
   with a picker when a product has more than one option. The + Add button always adds the
   variant that is shown. */
(() => {
  if (window.__rngUpsell) return;
  window.__rngUpsell = true;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  let C = {};
  try { C = JSON.parse((document.getElementById('rng-config') || {}).textContent || '{}'); } catch (e) {}
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const isDefault = (t) => !t || /^default title$/i.test(t);
  const sized = (url, w) => {
    if (!url) return '';
    const u = url.startsWith('//') ? 'https:' + url : url;
    return u + (u.includes('?') ? '&' : '?') + 'width=' + w;
  };
  function money(cents) {
    const n = Number(cents || 0) / 100;
    const group = (s, sep) => s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    const [i, d] = n.toFixed(2).split('.');
    return (C.moneyFormat || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals') return group(String(Math.round(n)), ',');
      if (k === 'amount_with_comma_separator') return group(i, '.') + ',' + d;
      if (k === 'amount_no_decimals_with_comma_separator') return group(String(Math.round(n)), '.');
      return group(i, ',') + '.' + d;
    });
  }

  const css = document.createElement('style');
  css.textContent = `
    .rng-up__variant { display: inline-block; margin-top: .2rem; padding: .1rem .6rem; border: 1px solid rgba(var(--rng-accent, 255,199,0), .7); color: rgb(var(--rng-accent, 255,199,0)); font-size: 1.1rem; font-weight: 700; letter-spacing: .04em; text-transform: uppercase; line-height: 1.5; justify-self: start; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .rng-up__select { width: 100%; max-width: 32rem; min-height: 3.6rem; margin-top: .4rem; padding: 0 1rem; border: 1px solid rgba(var(--color-foreground), .4); border-radius: 0; background: rgba(var(--color-foreground), .04); color: rgb(var(--color-foreground)); font: inherit; font-size: 1.25rem; }
    .rng-up__select option { color: #1f1f21; }
    .rng-up__img img { background: #fff; }
    .rng-up__price s { margin-left: .6rem; opacity: .55; color: rgb(var(--color-foreground)); font-size: .9em; }
    .rng-up.rng-up--page { margin-top: 2.4rem; margin-bottom: 2.4rem; }
    .rng-up--page .rng-up__heading { font-size: 1.8rem; margin-bottom: 1.2rem; }
    .rng-up--page .rng-up__list { display: grid; gap: 1rem; }
    @media (min-width: 750px) { .rng-up--page .rng-up__list { grid-template-columns: repeat(3, minmax(0, 1fr)); } }
    .rng-up--page .rng-up__item { grid-template-columns: 6.4rem minmax(0, 1fr); grid-template-areas: 'img info' 'btn btn'; padding: 1rem; }
    .rng-up--page .rng-up__img { grid-area: img; }
    .rng-up--page .rng-up__info { grid-area: info; }
    .rng-up--page .rng-up__add { grid-area: btn; width: 100%; }
  `;
  document.head.appendChild(css);

  const cache = new Map();
  function getProduct(href) {
    const handle = ((href || '').split('/products/')[1] || '').split(/[?#/]/)[0];
    if (!handle) return Promise.resolve(null);
    if (!cache.has(handle)) {
      cache.set(handle, fetch(`${root}products/${handle}.js`, { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null)).catch(() => null));
    }
    return cache.get(handle);
  }

  async function enhance(item) {
    if (item.dataset.rngV) return;
    item.dataset.rngV = '1';
    const btn = item.querySelector('[data-rng-add]');
    const title = item.querySelector('.rng-up__title');
    const priceEl = item.querySelector('.rng-up__price');
    const imgLink = item.querySelector('.rng-up__img');
    if (!btn || !title) return;
    const p = await getProduct(title.getAttribute('href'));
    if (!p || !p.variants || !p.variants.length) return;

    const available = p.variants.filter((v) => v.available);
    const multi = p.variants.length > 1;
    const vName = (v) => (isDefault(v.title) ? '' : (v.public_title || v.title));
    const info = item.querySelector('.rng-up__info');
    let tag = null;
    if (multi && info) {
      tag = document.createElement('span');
      tag.className = 'rng-up__variant';
      title.insertAdjacentElement('afterend', tag);
    }

    const apply = (v) => {
      btn.dataset.rngAdd = String(v.id);
      btn.disabled = !v.available;
      const url = `${p.url || root + 'products/' + p.handle}?variant=${v.id}`;
      title.setAttribute('href', url);
      if (imgLink) imgLink.setAttribute('href', url);
      if (priceEl) {
        priceEl.innerHTML = v.available
          ? esc(money(v.price)) + (v.compare_at_price > v.price ? ` <s>${esc(money(v.compare_at_price))}</s>` : '')
          : 'Sold out';
      }
      if (tag) { const n = vName(v); tag.textContent = n; tag.hidden = !n; tag.title = n; }
      const src = (v.featured_image && v.featured_image.src) || p.featured_image || '';
      if (imgLink && src) {
        let img = imgLink.querySelector('img');
        if (!img) {
          img = document.createElement('img');
          img.width = 64; img.height = 64; img.loading = 'lazy';
          imgLink.appendChild(img);
        }
        img.src = sized(src, 160);
        img.alt = p.title + (vName(v) ? ' – ' + vName(v) : '');
      }
    };

    let current = p.variants.find((v) => v.id === Number(btn.dataset.rngAdd)) || available[0] || p.variants[0];
    if (available.length > 1 && info) {
      const sel = document.createElement('select');
      sel.className = 'rng-up__select';
      sel.setAttribute('aria-label', p.title + ' – choose an option');
      sel.innerHTML = p.variants.map((v) =>
        `<option value="${v.id}"${v.id === current.id ? ' selected' : ''}${v.available ? '' : ' disabled'}>${esc(vName(v) || p.title)} · ${v.available ? esc(money(v.price)) : 'Sold out'}</option>`).join('');
      sel.addEventListener('change', () => {
        const v = p.variants.find((x) => x.id === Number(sel.value));
        if (v) apply(v);
      });
      info.appendChild(sel);
    }
    apply(current);
  }

  /* a11y: the image link duplicates the title link (and its image may have empty alt), so hide it from AT/tab order;
     tie each "+ Add" button to its product title; expose the visual heading as a heading. */
  let uid = 0;
  function a11y(box) {
    const h = box.querySelector('.rng-up__heading');
    if (h && !h.hasAttribute('role')) { h.setAttribute('role', 'heading'); h.setAttribute('aria-level', '2'); }
    box.querySelectorAll('.rng-up__item').forEach((item) => {
      const img = item.querySelector('.rng-up__img');
      if (img) { img.setAttribute('aria-hidden', 'true'); img.setAttribute('tabindex', '-1'); }
      const title = item.querySelector('.rng-up__title');
      const btn = item.querySelector('[data-rng-add]');
      if (title && btn && !btn.hasAttribute('aria-describedby')) {
        if (!title.id) title.id = 'rng-up-t' + (++uid);
        btn.setAttribute('aria-describedby', title.id);
      }
    });
  }

  // a11y: announce upsell add-to-cart results where no cart pop-up/drawer opens to do it (e.g. the cart page).
  let live = null;
  const announce = (msg) => {
    if (!live) {
      live = document.createElement('p');
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(() => { live.textContent = msg; }, 60);
  };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('.rng-up [data-rng-add]');
    if (!btn || btn.closest('#cart-notification, cart-drawer, #CartDrawer')) return;
    const item = btn.closest('.rng-up__item');
    const t = item && item.querySelector('.rng-up__title');
    const name = t ? t.textContent.trim() : '';
    const mo = new MutationObserver(() => {
      if (btn.textContent.trim() === '✓') { mo.disconnect(); announce((name ? name + ' ' : '') + 'added to cart'); }
    });
    mo.observe(btn, { childList: true, characterData: true, subtree: true });
    setTimeout(() => mo.disconnect(), 15000);
  }, true);

  function scan() {
    document.querySelectorAll('.rng-up').forEach((box) => {
      if (!box.dataset.rngPlaced) {
        box.dataset.rngPlaced = '1';
        if (!box.closest('#cart-notification, #CartDrawer, cart-drawer, .drawer, .page-width')) box.classList.add('page-width', 'rng-up--page');
      }
    });
    document.querySelectorAll('.rng-up').forEach(a11y);
    document.querySelectorAll('.rng-up__item:not([data-rng-v])').forEach(enhance);
  }

  let t;
  new MutationObserver(() => { clearTimeout(t); t = setTimeout(scan, 40); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
